export const server = import.meta.env.VITE_SERVER as string;
export const gptServer = import.meta.env.VITE_GPT_SERVER as string;
export const envMode =
  (import.meta.env.VITE_ENV_MODE as string) || 'Production';
export const twilioServer = import.meta.env.VITE_TWILIO_SERVER as string;
export const webSocketHomeServer = import.meta.env
  .VITE_WEBSOCKET_HOME_SERVER as string;
export const emotionServer = import.meta.env.VITE_EMOTION_SERVER as string;
export const flowChartServer = import.meta.env.VITE_FLOW_CHART_SERVER as string;
export const recaptchaSiteKey = import.meta.env
  .VITE_RECAPTCHA_SITE_KEY as string;
export const zetexaChatbotApiKey = import.meta.env
  .VITE_ZETEXA_CHATBOT_API_KEY as string;
export const exulttecChatbotApiKey = import.meta.env
  .VITE_EXULTTEC_CHATBOT_API_KEY as string;
export const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string;
export const menuDataUrl = import.meta.env.VITE_MENU_DATA_URL as string;
export const menuDataServer = import.meta.env.VITE_MENU_SERVER as string;
export const pythonServer = import.meta.env.VITE_PYTHON_SERVER as string;
export const agenticServer = import.meta.env
  .VITE_AGENTIC_SERVICE_SERVER as string;
export const windmillApiAuthKey = import.meta.env
  .VITE_WINDMILL_API_AUTH_KEY as string;
export const outboundCallServer = import.meta.env
  .VITE_OUTBOUND_CALL_SERVER as string;
export const agentLightingServer = import.meta.env
  .VITE_AGENT_LIGHTING_SERVER as string;
